import React, { FC } from 'react';
import clsx from 'clsx';
import { FieldProps } from 'formik';
import { isMobile } from 'react-device-detect';
import TextareaAutosize from 'react-textarea-autosize';

type Props = {
	classNames: string;
	inputElementClassNames?: string;
	label: string;
	required: boolean;
	type: string;
	disabled?: boolean;
	innerRef?: any;
	onChangeHandler: (
		e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
	) => void;
	labelClasses?: string;
	onBlur?: (
		e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
	) => void;
};
// eslint-disable-next-line react/function-component-definition
export const KntAutoSizeTextField: FC<Props & FieldProps> = ({
	classNames,
	label,
	field: { name, value, onChange, ...restField },
	form: { touched, errors },
	type = 'text',
	required,
	innerRef,
	onChangeHandler,
	disabled,
	inputElementClassNames = '',
	labelClasses = '',
	onBlur,
	...restProps
}) => {
	const inputClassNames = clsx(
		'border  border-transparent rounded-lg text-xs px-6 py-3.5' +
			' outline-none transition focus:border-primary focus:shadow-lg ' +
			'w-full placeholder-current placeholder-kgrey dark:bg-kdark hover:border-primary',
		inputElementClassNames,
		errors[name] && touched[name] && 'border-red-500',
		{ 'pointer-events-none bg-kgrey-disabled-bg': disabled, 'bg-kgrey-light-grey-1': !disabled }
	);
	return (
		<div className={clsx('mb-4', classNames)}>
			{label ? (
				<label
					className={clsx(
						{ 'ml-2 mb-2 block text-sm font-light text-kgrey-menuText': !labelClasses },
						labelClasses
					)}
					htmlFor={name}
				>
					<span>{label}</span>
					{required ? <sup>*</sup> : null}
				</label>
			) : null}
			<div className="relative">
				{type === 'textarea' ? (
					<TextareaAutosize
						name={name}
						value={value}
						className={inputClassNames}
						autoComplete="off"
						maxRows={isMobile ? 2 : 5}
						id={name}
						disabled={disabled}
						ref={innerRef}
						onChange={(e) => {
							onChange(e);
							if (typeof onChangeHandler === 'function') onChangeHandler(e);
						}}
						{...restProps}
						{...restField}
						onBlur={onBlur}
					/>
				) : (
					<input
						id={name}
						type={type}
						name={name}
						value={value}
						className={inputClassNames}
						ref={innerRef}
						disabled={disabled}
						onChange={(e) => {
							onChange(e);
							if (typeof onChangeHandler === 'function') onChangeHandler(e);
						}}
						{...restProps}
						{...restField}
					/>
				)}
			</div>
			{errors[name] && touched[name] ? (
				<span className="text-xs text-red-500">{errors[name]}</span>
			) : null}
		</div>
	);
};

KntAutoSizeTextField.defaultProps = {
	disabled: false
};
